<template>
  <div></div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    productClass: { type: String },
  },
  computed: {
    ...mapState([
      "dndTourDone",
      "crosssellTourDone",
      "basicTourDone",
      "similarOpen",
      "recentOpen",
      "ctaOpen",
      "crosssellOpen",
      "crosssellEnabled",
      "dndEnabled",
      "content",
      "lang",
    ]),
  },
  methods: {
    dummy_startTour() {
      return null;
    },
    startTour(force) {
      const reset = force ? force : false;
      const isPanelShowing =
        this.crosssellOpen ||
        this.similarOpen ||
        this.recentOpen ||
        this.ctaOpen
          ? true
          : false;

      if (!isPanelShowing) {
        if (reset) {
          this.$store.commit("RESET_TOUR", "dnd");
        }
        if (!this.dndTourDone && this.dndEnabled) {
          this.startDndTour();
        }
      }
    },
    startDndTour() {
      if (window.dndTour) {
        if (window.dndTour.isActive()) {
          return null;
        } else {
          window.dndTour.start();
          return null;
        }
      }
      let vm = this;
      let prnt, productParent;
      prnt = document.querySelector(`${vm.productClass}`).parentNode;
      if (window.location.host == "www.interflora.es") {
        if (document.querySelector("#eb-results")) {
          prnt = document.querySelector("#eb-results");
        } else {
          prnt = document.querySelector(".products-list");
        }
      }
      productParent = prnt.className
        ? "." + prnt.className.split(" ")[0]
        : prnt.id
        ? "#" + prnt.id
        : prnt;
      const dndTour = vm.$shepherd({
        useModalOverlay: true,
        defaultStepOptions: {
          classes: "shopbox-tour",
        },
        classPrefix: "shopbox-app-",
        stepsContainer: document.getElementById("shopbox"),
        modalContainer: document.getElementById("shopbox"),
      });
      window.dndTour = dndTour;
      this.$nextTick(() => {
        let tour = window.dndTour;
        tour.on("complete", () => {
          vm.$store.commit("COMPLETE_TOUR", "dnd");
        });
        tour.addStep({
          attachTo: { element: ".sb-btn--sm", on: "top" },
          title: this.content[this.lang].tutorial.stepOne.heading,
          text: this.content[this.lang].tutorial.stepOne.body,
          modalOverlayOpeningRadius: 25,
          modalOverlayOpeningPadding: 4,
          buttons: [
            {
              action() {
                return this.complete();
              },
              classes: "shepherd-button-secondary",
              text: this.content[this.lang].buttons.exit,
            },
            {
              action() {
                document.body.classList.add("sb-tutorial-arrow");
                return tour.next();
              },
              text: this.content[this.lang].buttons.next,
            },
          ],
        });
        tour.addStep({
          modalOverlayOpeningRadius: 6,
          modalOverlayOpeningPadding: 1,
          attachTo: {
            element: productParent,
            on: "top",
          },
          title: this.content[this.lang].tutorial.stepTwo.heading,
          arrow: true,
          text: this.content[this.lang].tutorial.stepTwo.body,
          buttons: [
            {
              action() {
                document.body.classList.remove("sb-tutorial-arrow");
                return this.back();
              },
              classes: "shepherd-button-secondary",
              text: this.content[this.lang].buttons.back,
            },
          ],
        });

        window.dndTour.start();
      });
    },
  },
};
</script>

<style>
.sb-tutorial-arrow .sb-menu--btn_group:after {
  opacity: 1 !important;
  visibility: visible !important;
  animation: move 0.3s infinite alternate;
}
@keyframes move {
  0% {
    transform: translateY(-50%) translateX(0px);
  }
  100% {
    transform: translateY(-50%) translateX(10px);
  }
}
.sb-product-btn {
  display: inline-flex;
  background: #083d77 !important;
  padding: 0px 4px !important;
  border-radius: 2px;
  color: #fff !important;
  font-size: 10px;
  line-height: 16px;
}
.shepherd-enabled.shepherd-element {
  opacity: 1 !important;
  visibility: visible !important;
  pointer-events: all !important;
}
.shepherd-element {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.2);
  max-width: 350px;
  opacity: 0;
  outline: none;
  transition: opacity 0.3s, visibility 0.3s;
  visibility: hidden;
  width: 100%;
  z-index: 2147483645;
  /* overflow: hidden; */
  margin: 10px !important;
}

.shepherd-element[data-popper-reference-hidden]:not(.shepherd-centered) {
  opacity: 0;
  pointer-events: none;
  visibility: hidden;
}
.shepherd-element,
.shepherd-element *,
.shepherd-element :after,
.shepherd-element :before {
  box-sizing: border-box;
  font-family: sans-serif;
}
.shepherd-arrow,
.shepherd-arrow:before {
  position: absolute;
  width: 16px;
  height: 16px;
  z-index: -1;
}
.shepherd-arrow:before {
  content: "";
  transform: rotate(45deg);
  background: #fff;
}
.shepherd-element[data-popper-placement^="top"] > .shepherd-arrow {
  bottom: -8px;
}
.shepherd-element[data-popper-placement^="bottom"] > .shepherd-arrow {
  top: -8px;
}
.shepherd-element[data-popper-placement^="left"] > .shepherd-arrow {
  right: -8px;
}
.shepherd-element[data-popper-placement^="right"] > .shepherd-arrow {
  left: -8px;
}
.shepherd-element.shepherd-centered > .shepherd-arrow {
  opacity: 0;
}

.shepherd-element.shepherd-has-title[data-popper-placement^="bottom"]
  > .shepherd-arrow:before {
  background-color: #e6e6e6;
}
.shepherd-target-click-disabled.shepherd-enabled.shepherd-target,
.shepherd-target-click-disabled.shepherd-enabled.shepherd-target * {
  pointer-events: none;
}
.shepherd-modal-overlay-container {
  -ms-filter: progid:dximagetransform.microsoft.gradient.alpha(Opacity=50);
  filter: alpha(opacity=50);
  height: 0;
  left: 0;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
  position: fixed;
  top: 0;
  transition: all 0.3s ease-out, height 0ms 0.3s, opacity 0.3s 0ms;
  width: 100vw;
  z-index: 9997;
}
.shepherd-modal-overlay-container.shepherd-modal-is-visible {
  height: 100vh;
  opacity: 0.5;
  transition: all 0.3s ease-out, height 0s 0s, opacity 0.3s 0s;
}
.shepherd-modal-overlay-container.shepherd-modal-is-visible path {
  pointer-events: all;
}
.shepherd-content {
  /* border-radius: 5px; */
  outline: none;
  padding: 0;
}
.shepherd-footer {
  display: flex;
  border-radius: 8px;
}

.shepherd-header {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 8px !important;
  border-radius: 8px 8px 0 0;
  max-width: 100%;
}

.shepherd-has-title .shepherd-content .shepherd-header {
  background: #e6e6e6 !important;
  border: none !important;
  padding: 0 1em;
}
.shepherd-text {
  color: rgba(0, 0, 0, 0.75);
  font-size: 14px;
  line-height: 1.3em;
  padding: 14px !important;
  text-transform: none !important;
}
.shepherd-title {
  margin: 1em 0 !important;
  font-size: 18px !important;
  line-height: 1.3em;
  text-transform: none !important;
}

.shepherd-button {
  width: 50%;
  background: var(--shopbox-main) !important;
  text-align: center !important;
  font-size: 14px !important;
  padding: 10px !important;
  border: 0;
  color: hsla(0, 0%, 100%, 0.75) !important;
  cursor: pointer;
  transition: all 0.5s ease;
  line-height: 16px !important;
}
.shepherd-button:not(:disabled):hover {
  background: var(--shopbox-main) !important;
  filter: brightness(90%);
  color: hsla(0, 0%, 100%, 0.75) !important;
}
.shepherd-button.shepherd-button-secondary {
  background: #f1f2f3 !important;
  color: rgba(0, 0, 0, 0.75) !important;
}
.shepherd-button.shepherd-button-secondary:not(:disabled):hover {
  background: #d6d9db !important;
  color: rgba(0, 0, 0, 0.75);
}
.shepherd-button:disabled {
  cursor: not-allowed;
}
</style>
